import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: "48",
  width: "48",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M14.5,20a1,1,0,0,1-1-.82l-1.27-7.11a.25.25,0,0,0-.5,0l-1.27,7.11a1,1,0,0,1-2,0L7.22,11.9a.25.25,0,0,0-.5,0l-.24,1.29a1,1,0,0,1-1,.81H1a1,1,0,0,1-1-1,1,1,0,0,1,1-1H4.46a.25.25,0,0,0,.25-.2L6,4.82A1,1,0,0,1,7,4H7a1,1,0,0,1,1,.82l1.27,7.11a.25.25,0,0,0,.5,0L11,4.82a1,1,0,0,1,2,0l1.27,7.11a.25.25,0,0,0,.5,0L16,4.82A1,1,0,0,1,17,4h0a1,1,0,0,1,1,.82l1.31,7a.25.25,0,0,0,.25.2H23a1,1,0,0,1,1,1,1,1,0,0,1-1,1H18.5a1,1,0,0,1-1-.81l-.24-1.29a.25.25,0,0,0-.5,0l-1.3,7.28A1,1,0,0,1,14.5,20Z",
      fill: "currentColor"
    }, null, -1)
  ])))
}
export default { render: render }